import React from "react";

const Hexagon = (props) => {
  // Match Cushion's coordinate system for consistent overlay math
  const viewBoxWidth = 96;
  const viewBoxHeight = 100;

  // Helpers for overlay placement (same pattern as Cushion)
  const x = (percentX) => percentX * viewBoxWidth;
  const y = (percentY) => percentY * viewBoxHeight;

  // Measurement label boxes (percent-based like Cushion)
  const lengthXPrcnt = 0.15;
  const lengthYPrcnt = 0.5;

  const widthXPrcnt = 0.85;
  const widthYPrcnt = 0.32;

  const lengthX = lengthXPrcnt * viewBoxWidth;
  const lengthY = lengthYPrcnt * viewBoxHeight;

  const widthX = widthXPrcnt * viewBoxWidth;
  const widthY = widthYPrcnt * viewBoxHeight;

  const lineColor = "#4a4a4a";
  const diagramStrokeWidth = "0.01";
  const diagramFontSize = 0.05;

  // --- Fit original hexagon geometry into this 96x86 box ---
  // Original SVG bounds (from your hexagon SVG)
  const origW = 47.57;
  const origH = 85.85;

  // Small padding to prevent stroke clipping; tweak via prop if needed
  const pad = props.pad ?? 1.0;

  const innerW = viewBoxWidth - 2 * pad;
  const innerH = viewBoxHeight - 2 * pad;

  // Uniform scale so the whole hex fits inside the padded area
  const s = Math.min(innerW / origW, innerH / origH);

  // Center translation
  const tx = pad + (innerW - origW * s) / 2;
  const ty = pad + (innerH - origH * s) / 2;

  const stroke = props.color || "#4a4a4a";

  const cls = {
    fill: "none",
    stroke,
    strokeWidth: props.stroke_width ?? 2,
    strokeMiterlimit: 10,
    vectorEffect: "non-scaling-stroke",
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={props.width}
      height={props.height}
      preserveAspectRatio={props.preserveAspectRatio}
      style={{ display: "block" }}
    >
      {/* Centered & scaled hexagon geometry */}
      <g transform={`translate(${tx}, ${ty}) scale(${s})`}>
        <polygon
          style={cls}
          points=".68 21.31 24.32 .67 46.72 20.96 47.07 63.47 23.79 85.17 .5 63.82 .68 21.31"
        />
        <polygon
          style={cls}
          points="24.14 9.14 42.66 25.72 42.49 58.71 24.14 75.64 5.44 59.24 5.44 25.72 24.14 9.14"
        />
        <polygon
          style={cls}
          points="23.96 19.19 37.19 31.01 37.02 54.3 23.79 66.29 10.73 54.12 10.73 31.19 23.96 19.19"
        />
        <path style={cls} d="M24.32.67l-.35,18.52.35-18.52Z" />
        <path style={cls} d="M37.19,31.01l9.53-10.06-9.53,10.06Z" />
        <path style={cls} d="M37.02,54.3l10.06,9.17-10.06-9.17Z" />
        <path style={cls} d="M23.79,85.17v-18.88,18.88Z" />
        <path style={cls} d="M.5,63.82l10.23-9.7L.5,63.82Z" />
        <path style={cls} d="M.68,21.31l10.06,9.88L.68,21.31Z" />
      </g>

      {/* Optional measurement overlay (same style/behavior as Cushion) */}
      {props.show_diagram && (
        <>
          {/* Vertical "Length" ruler */}
          <line
            x1={x(0.25)}
            y1={y(-0.01)}
            x2={x(0.25)}
            y2={y(0.98)}
            stroke={lineColor}
            strokeWidth=".6"
          />
          <line
            x1={x(0.23)}
            y1={y(-0.01)}
            x2={x(0.27)}
            y2={y(-0.01)}
            stroke={lineColor}
            strokeWidth=".6"
          />
          <line
            x1={x(0.23)}
            y1={y(0.98)}
            x2={x(0.27)}
            y2={y(0.98)}
            stroke={lineColor}
            strokeWidth=".6"
          />
          <rect
            x={lengthX}
            y={lengthY}
            width="20"
            height="11"
            rx="0.8"
            fill="white"
          />
          <text
            x={lengthX + 2}
            y={lengthY + 4}
            fontSize={y(diagramFontSize)}
            stroke={lineColor}
            strokeWidth={diagramStrokeWidth}
          >
            Length:
          </text>
          <text
            x={lengthX + 1}
            y={lengthY + 10}
            fontSize={y(diagramFontSize)}
            stroke={lineColor}
            strokeWidth={diagramStrokeWidth}
          >
            {props?.diamond?.Measurement1}
          </text>

          {/* Horizontal "Width" ruler */}
          <line
            x1={x(-0.008)}
            y1="25"
            x2={x(0.965)}
            y2="25"
            stroke={lineColor}
            strokeWidth=".6"
          />
          <line
            x1={x(-0.008)}
            y1="23"
            x2={x(-0.008)}
            y2="27"
            stroke={lineColor}
            strokeWidth=".6"
          />
          <line
            x1={x(0.965)}
            y1="23"
            x2={x(0.965)}
            y2="27"
            stroke={lineColor}
            strokeWidth=".6"
          />
          <rect
            x={widthX}
            y={widthY}
            width="19"
            height="11"
            rx="0.8"
            fill="white"
          />
          <text
            x={widthX + 2}
            y={widthY + 4}
            fontSize={y(diagramFontSize)}
            stroke={lineColor}
            strokeWidth={diagramStrokeWidth}
          >
            Width:
          </text>
          <text
            x={widthX + 1}
            y={widthY + 10}
            fontSize={y(diagramFontSize)}
            stroke={lineColor}
            strokeWidth={diagramStrokeWidth}
          >
            {props?.diamond?.Measurement2}
          </text>
        </>
      )}
    </svg>
  );
};

export default Hexagon;
